/** Service Desk console: Service settings, tab na General - mga module, uri ng customer at template pack (SD-S1-67 / 68 / 69). */
export const serviceSettings = {
  modules: {
    title: "Mga module ng Service",
    intro: "I-on lang ang ginagamit ng team mo. Ang module na naka-off ay mawawala sa menu, \"hindi mahanap\" ang mga pahina nito at naka-pause ang mga default nito; walang binubura.",
    alwaysOn: "Laging naka-on",
    hiddenInB2c: "Nakatago para sa indibidwal na customer",
    switchedOn: "Naka-on ang {{module}}.",
    switchedOff: "Naka-off ang {{module}}. Nananatili ang data nito.",
    tickets: { title: "Mga ticket", hint: "Mga request, sagot, SLA clock at CSAT. Meron nito ang bawat workspace." },
    organisations: { title: "Mga organisasyon", hint: "Mga kumpanyang kliyente, ang kanilang mga contact, role at shared visibility, para sa business customer." },
    assets: { title: "Mga asset", hint: "Mga naka-install na kagamitan na may serial number, warranty at service history." },
    projects: { title: "Mga proyekto / installation", hint: "Mga installation na may yugto, open items, sign-off at handover." },
    visits: { title: "Mga pagbisita sa field", hint: "Mga naka-iskedyul na bisita ng engineer na may checklist at ulat." },
    orders: { title: "Mga order at katalogo", hint: "Katalogo ng produkto at mga order ng kliyente sa pamamagitan ng order system mo." },
  },
  mode: {
    title: "Sino ang mga customer mo?",
    intro: "Dito nakasalalay kung may mga organisasyon. Gumagana ang mga ticket at contact sa bawat mode, at nananatili ang lahat ng ticket kapag bumalik ka.",
    saved: "Na-save ang uri ng customer.",
    b2b: { label: "Mga negosyo", hint: "Mga kumpanyang may contact: mga screen ng organisasyon, role, kasamahan at shared na ticket." },
    b2c: { label: "Mga indibidwal", hint: "Bawat ticket ay pag-aari ng isang tao. Nakatago ang mga screen ng organisasyon, role, kasamahan at shared visibility." },
    mixed: { label: "Pareho", hint: "Magkasama ang mga kumpanya at indibidwal na customer." },
  },
  packs: {
    title: "Industry template pack",
    intro: "Ang pack ay nagbibigay sa desk mo ng mga salita, uri ng ticket, field, macro at sample SLA ng isang industriya. Nagdaragdag lang ito: walang binubura o pinapalitan na na-edit mo, at puwede kang mag-apply ng ibang pack mamaya.",
    suggested: "Iminumungkahi",
    current: "Ginagamit",
    additive: "Kapag inulit ang pag-apply, idaragdag lang ang kulang.",
    notApplied: "Wala pang na-apply na pack. Generic na salita at ang mga built-in na uri ng ticket ang gamit.",
    preview: "I-preview at i-apply",
    previewTitle: "I-apply ang {{name}} pack",
    previewHint: "Ito ang magbabago. Walang isusulat hangga't hindi mo ina-apply.",
    previewRegion: "Ang magbabago",
    previewError: "Hindi ma-preview ang pack na ito",
    cancel: "Kanselahin",
    apply: "I-apply ang pack",
    applied: "Na-apply ang {{name}}: {{added}} idinagdag, {{updated}} in-update.",
    nothingToAdd: "Nandiyan na ang lahat ng nasa pack na ito. Walang idadagdag.",
    suggestions: "Kasama rin sa pack na ito, iaalok kapag bumukas ang mga screen nila: {{parts}}.",
    change: { add: "Idagdag", update: "I-update", keep: "Pinanatili", plan_limit: "Wala sa plano mo" },
    part: {
      modules: "Mga module",
      customer_mode: "Uri ng customer",
      vocabulary: "Mga salita sa console at portal",
      ticket_types: "Mga uri ng ticket",
      type_labels: "Mga built-in na uri na binago ang pangalan",
      fields: "Mga field",
      type_fields: "Mga field sa mga uri",
      status_labels: "Mga label ng status na nakikita ng kliyente",
      resolution_codes: "Mga resolution code",
      macros: "Mga macro",
      csat_reasons: "Mga dahilan sa CSAT",
      calendars: "Mga business calendar",
      sla_policies: "Mga patakaran ng SLA",
    },
    suggestion: {
      home_options: "mga opsyon sa Home ng widget",
      stage_templates: "mga template ng yugto ng proyekto",
      visit_checklists: "mga checklist ng pagbisita",
      asset_categories: "mga kategorya ng asset",
      connector_operations: "mga operasyon ng connector",
    },
  },
} as const;
